import React from "react";
import { Link } from "react-router-dom";
import "./CookiePolicy.css";
function CookiePolicy() {
  return (
    <div className="cookie-policy">
      <div className="cookie-container">
        <h2>Cookies And Other Tracking Technologies:</h2>

        <p>
          (a) Cookies are small files that a site or its service provider transfers to your device’s
          hard drive through your web browser (if you permit it to) that enables the sites or service
          providers’ systems to recognise your browser and capture and remember certain information.
          We use both Session and Persistent Cookies for the purposes set out below:
        </p>

        <ul>
          <li>
            <strong>Necessary / Essential Cookies</strong> <br />
            <em>Type:</em> Session Cookies <br />
            <em>Administered by:</em> Us <br />
            <em>Purpose:</em> These Cookies are essential to provide You with services available through
            the Platform and to enable You to use some of its features. They help to authenticate users
            and prevent fraudulent use of user accounts. Without these Cookies, the services that You
            have asked for cannot be provided, and We only use these Cookies to provide You with those
            services.
          </li>
          <li>
            <strong>Cookies Policy / Notice Acceptance Cookies</strong> <br />
            <em>Type:</em> Persistent Cookies <br />
            <em>Administered by:</em> Us <br />
            <em>Purpose:</em> These Cookies identify if users have accepted the use of cookies on the
            Website.
          </li>
          <li>
            <strong>Functionality Cookies</strong> <br />
            <em>Type:</em> Persistent Cookies <br />
            <em>Administered by:</em> Us <br />
            <em>Purpose:</em> These Cookies allow us to remember choices You make when You use our
            Platform. The purpose of these Cookies is to provide You with a more personal experience.
          </li>
          <li>
            <strong>Tracking and Performance Cookies</strong> <br />
            <em>Type:</em> Persistent Cookies <br />
            <em>Administered by:</em> Third-Parties <br />
            <em>Purpose:</em> These Cookies are used to track information about traffic to the Platform
            and how users use the Platform. The information gathered via these Cookies may directly or
            indirectly identify you as an individual visitor. This is because the information collected
            is typically linked to a pseudonymous identifier associated with the device you use to access
            the Website. We may also use these Cookies to test new pages, features or new functionality
            of the Website to see how our users react to them.
          </li>
        </ul>

        <p>
          (b) We use cookies to help us distinguish you from other users of the Platform, understand and
          save your preferences for future visits, keep track of advertisements and compile aggregate
          data about site traffic and site interaction so that we can offer you a seamless user
          experience. We may contact third-party service providers to assist us in better understanding
          our site visitors. These service providers are not permitted to use the information collected
          on our behalf except to help us conduct and improve our business.
        </p>

        <p>
          (c) Additionally, you may encounter cookies or other similar devices on certain pages of the
          Platform that are placed by third parties. We do not control the use of cookies by third
          parties. If you send us personal correspondence, such as emails, or if other users or third
          parties send us correspondence about your activities or postings on the Platform, we may
          collect such information within a file specific to you.
        </p>

        {/* <div className="back-link">
          <Link to="/">← Back to Home</Link>
        </div> */}
      </div>
    </div>
  );
}

export default CookiePolicy;
